// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/datasource/v1/catalog.proto" (package "c1.api.integration.datasource.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../../google/protobuf/field_mask";
import { ConfigSchema } from "../../connector/v1/catalog";
import { Any } from "../../../../../google/protobuf/any";
import { Timestamp } from "../../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceInstallationView
 */
export interface DataSourceInstallationView {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceInstallation installation = 1;
     */
    installation?: DataSourceInstallation;
    /**
     * @generated from protobuf field: string users_path = 2;
     */
    usersPath: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceInstallation
 */
export interface DataSourceInstallation {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceCatalog catalog = 1;
     */
    catalog?: DataSourceCatalog;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Any config = 8;
     */
    config?: Any;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp first_validated_at = 9;
     */
    firstValidatedAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated string admin_user_ids = 10;
     */
    adminUserIds: string[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceInstallationRef
 */
export interface DataSourceInstallationRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalog
 */
export interface DataSourceCatalog {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: string icon_url = 4 [deprecated = true];
     */
    iconUrl: string;
    /**
     * @deprecated
     * @generated from protobuf field: string logo_url = 5 [deprecated = true];
     */
    logoUrl: string;
    /**
     * @generated from protobuf field: bool installed = 6;
     */
    installed: boolean;
    /**
     * @generated from protobuf field: string help_url = 7;
     */
    helpUrl: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchRequest
 */
export interface DataSourceCatalogServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchResponse
 */
export interface DataSourceCatalogServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.datasource.v1.DataSourceCatalog list = 1;
     */
    list: DataSourceCatalog[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceExpandMask
 */
export interface DataSourceExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetRequest
 */
export interface DataSourceCatalogServiceGetRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsRequest
 */
export interface DataSourceCatalogServiceSearchInstallationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string catalog_ids = 4;
     */
    catalogIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.integration.datasource.v1.DataSourceInstallationRef refs = 5;
     */
    refs: DataSourceInstallationRef[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsResponse
 */
export interface DataSourceCatalogServiceSearchInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.datasource.v1.DataSourceInstallation list = 1;
     */
    list: DataSourceInstallation[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaRequest
 */
export interface DataSourceCatalogServiceConfigurationSchemaRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaResponse
 */
export interface DataSourceCatalogServiceConfigurationSchemaResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConfigSchema schema = 1;
     */
    schema?: ConfigSchema;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateInstallationRequest
 */
export interface DataSourceCatalogServiceCreateInstallationRequest {
    /**
     * @generated from protobuf field: google.protobuf.Any config = 1;
     */
    config?: Any;
    /**
     * @generated from protobuf field: string catalog_id = 2;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateDelegatedInstallationRequest
 */
export interface DataSourceCatalogServiceCreateDelegatedInstallationRequest {
    /**
     * @generated from protobuf field: google.protobuf.Any config = 1;
     */
    config?: Any;
    /**
     * @generated from protobuf field: string catalog_id = 2;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 5;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceDeleteInstallationRequest
 */
export interface DataSourceCatalogServiceDeleteInstallationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationRequest
 */
export interface DataSourceCatalogServiceGetInstallationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceExpandMask expand_mask = 2;
     */
    expandMask?: DataSourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationResponse
 */
export interface DataSourceCatalogServiceGetInstallationResponse {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceInstallationView installation_view = 1;
     */
    installationView?: DataSourceInstallationView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceUpdateInstallationRequest
 */
export interface DataSourceCatalogServiceUpdateInstallationRequest {
    /**
     * @generated from protobuf field: c1.api.integration.datasource.v1.DataSourceInstallation installation = 1;
     */
    installation?: DataSourceInstallation;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceInstallationView$Type extends MessageType<DataSourceInstallationView> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceInstallationView", [
            { no: 1, name: "installation", kind: "message", T: () => DataSourceInstallation },
            { no: 2, name: "users_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceInstallationView
 */
export const DataSourceInstallationView = new DataSourceInstallationView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceInstallation$Type extends MessageType<DataSourceInstallation> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceInstallation", [
            { no: 1, name: "catalog", kind: "message", T: () => DataSourceCatalog },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "config", kind: "message", T: () => Any },
            { no: 9, name: "first_validated_at", kind: "message", T: () => Timestamp },
            { no: 10, name: "admin_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceInstallation
 */
export const DataSourceInstallation = new DataSourceInstallation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceInstallationRef$Type extends MessageType<DataSourceInstallationRef> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceInstallationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceInstallationRef
 */
export const DataSourceInstallationRef = new DataSourceInstallationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalog$Type extends MessageType<DataSourceCatalog> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "logo_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "installed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalog
 */
export const DataSourceCatalog = new DataSourceCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchRequest$Type extends MessageType<DataSourceCatalogServiceSearchRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchRequest
 */
export const DataSourceCatalogServiceSearchRequest = new DataSourceCatalogServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchResponse$Type extends MessageType<DataSourceCatalogServiceSearchResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataSourceCatalog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchResponse
 */
export const DataSourceCatalogServiceSearchResponse = new DataSourceCatalogServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceExpandMask$Type extends MessageType<DataSourceExpandMask> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "admin_user_ids"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceExpandMask
 */
export const DataSourceExpandMask = new DataSourceExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceGetRequest$Type extends MessageType<DataSourceCatalogServiceGetRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceGetRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetRequest
 */
export const DataSourceCatalogServiceGetRequest = new DataSourceCatalogServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchInstallationsRequest$Type extends MessageType<DataSourceCatalogServiceSearchInstallationsRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataSourceInstallationRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsRequest
 */
export const DataSourceCatalogServiceSearchInstallationsRequest = new DataSourceCatalogServiceSearchInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceSearchInstallationsResponse$Type extends MessageType<DataSourceCatalogServiceSearchInstallationsResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DataSourceInstallation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceSearchInstallationsResponse
 */
export const DataSourceCatalogServiceSearchInstallationsResponse = new DataSourceCatalogServiceSearchInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceConfigurationSchemaRequest$Type extends MessageType<DataSourceCatalogServiceConfigurationSchemaRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaRequest
 */
export const DataSourceCatalogServiceConfigurationSchemaRequest = new DataSourceCatalogServiceConfigurationSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceConfigurationSchemaResponse$Type extends MessageType<DataSourceCatalogServiceConfigurationSchemaResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaResponse", [
            { no: 1, name: "schema", kind: "message", T: () => ConfigSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceConfigurationSchemaResponse
 */
export const DataSourceCatalogServiceConfigurationSchemaResponse = new DataSourceCatalogServiceConfigurationSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceCreateInstallationRequest$Type extends MessageType<DataSourceCatalogServiceCreateInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateInstallationRequest", [
            { no: 1, name: "config", kind: "message", T: () => Any },
            { no: 2, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateInstallationRequest
 */
export const DataSourceCatalogServiceCreateInstallationRequest = new DataSourceCatalogServiceCreateInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceCreateDelegatedInstallationRequest$Type extends MessageType<DataSourceCatalogServiceCreateDelegatedInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateDelegatedInstallationRequest", [
            { no: 1, name: "config", kind: "message", T: () => Any },
            { no: 2, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceCreateDelegatedInstallationRequest
 */
export const DataSourceCatalogServiceCreateDelegatedInstallationRequest = new DataSourceCatalogServiceCreateDelegatedInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceDeleteInstallationRequest$Type extends MessageType<DataSourceCatalogServiceDeleteInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceDeleteInstallationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceDeleteInstallationRequest
 */
export const DataSourceCatalogServiceDeleteInstallationRequest = new DataSourceCatalogServiceDeleteInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceGetInstallationRequest$Type extends MessageType<DataSourceCatalogServiceGetInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => DataSourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationRequest
 */
export const DataSourceCatalogServiceGetInstallationRequest = new DataSourceCatalogServiceGetInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceGetInstallationResponse$Type extends MessageType<DataSourceCatalogServiceGetInstallationResponse> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationResponse", [
            { no: 1, name: "installation_view", kind: "message", T: () => DataSourceInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceGetInstallationResponse
 */
export const DataSourceCatalogServiceGetInstallationResponse = new DataSourceCatalogServiceGetInstallationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataSourceCatalogServiceUpdateInstallationRequest$Type extends MessageType<DataSourceCatalogServiceUpdateInstallationRequest> {
    constructor() {
        super("c1.api.integration.datasource.v1.DataSourceCatalogServiceUpdateInstallationRequest", [
            { no: 1, name: "installation", kind: "message", T: () => DataSourceInstallation, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.datasource.v1.DataSourceCatalogServiceUpdateInstallationRequest
 */
export const DataSourceCatalogServiceUpdateInstallationRequest = new DataSourceCatalogServiceUpdateInstallationRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.integration.datasource.v1.DataSourceCatalogService
 */
export const DataSourceCatalogService = new ServiceType("c1.api.integration.datasource.v1.DataSourceCatalogService", [
    { name: "ConfigurationSchema", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceConfigurationSchemaRequest, O: DataSourceCatalogServiceConfigurationSchemaResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceGetRequest, O: DataSourceCatalog },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceSearchRequest, O: DataSourceCatalogServiceSearchResponse },
    { name: "SearchInstallations", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceSearchInstallationsRequest, O: DataSourceCatalogServiceSearchInstallationsResponse },
    { name: "CreateInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceCreateInstallationRequest, O: DataSourceInstallation },
    { name: "CreateDelegatedInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceCreateDelegatedInstallationRequest, O: DataSourceInstallation },
    { name: "DeleteInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceDeleteInstallationRequest, O: Empty },
    { name: "GetInstallation", options: { "authz.method": { role: "VIEWER" } }, I: DataSourceCatalogServiceGetInstallationRequest, O: DataSourceCatalogServiceGetInstallationResponse },
    { name: "UpdateInstallation", options: { "authz.method": { role: "EDITOR" } }, I: DataSourceCatalogServiceUpdateInstallationRequest, O: DataSourceInstallation }
]);
